import { Icon, IconComponent } from '@graftcode/design-system'

import { getAcademyExternalUrl } from '@/shared/docs-shared.utils'
import { ACADEMY_BACK_LINK_TEST_IDS } from '@/shared/docs-test-ids.const'

import styles from './AcademyBackLink.module.scss'

type AcademyBackLinkProps = {
  className?: string
}

export function AcademyBackLink({ className }: AcademyBackLinkProps) {
  const academyUrl = getAcademyExternalUrl()
  const linkClassName = className ? `${styles.link} ${className}` : styles.link

  return (
    <a
      data-testid={ACADEMY_BACK_LINK_TEST_IDS.root}
      href={academyUrl}
      className={linkClassName}
      aria-label="Go to Academy home"
    >
      <IconComponent icon={Icon.ArrowLeftRegular} size={16} className={styles.leadingArrow} />
      <span className={styles.iconBox}>
        <IconComponent icon={Icon.GCAcademy} size={20} />
      </span>
      <span className={styles.text}>
        <span className={styles.label}>Academy</span>
        <span className={styles.hint}>Back to home</span>
      </span>
    </a>
  )
}
